import { useSelector } from 'react-redux';

import { useAPIV2 } from '../../../yoello-lib/modules/API2/useAPIv2'
import APIExtensions from '../../../yoello-lib/modules/API2/APIDefs';
import UserManagementView from './UserManagementView';
import UserManagementDialogues from './Dialogues';
import { useMemo, useState } from 'react';
import { IMerchantAccount } from '../../../interfaces/IMerchantAccount';
import { useTranslation } from 'react-i18next';
import { HTTPMethods } from '../../../yoello-lib/modules/API/API';

export interface IInvitedMerchant {
  auth0_id: string;
created_on: string;
id: string;
invitation_accepted: false
merchant_email: string;
permission_sets: string[];
updated_on: string;
venue_id: string;
}
const UserManagement = () => {
  const venueId = useSelector((state: any) => state.selectedVenueId);
  const { isLoading, callAPI } = useAPIV2(APIExtensions.venueMerchant, {
    onMountDisabled:true
  });
  const { apiData:apiInvitationsData, isLoading:invitationsIsLoading, callAPI:invitationsListApi }: any = useAPIV2(APIExtensions.venueMerchant, {
    query: `${venueId}/merchants/invitations`,
    yoelloAPIParams: { size: 200, include_disabled: true },
  });
  const [users, setUsers] = useState<any[]>([])
  const { t } = useTranslation();


  async function getMerchants(){
    try{
      const { isSuccessful, data} =  await callAPI(HTTPMethods.GET,{
        query: `${venueId}/merchants`,
        yoelloAPIParams: { size: 200, include_disabled: true },
      });
      if(isSuccessful && data){
        setUsers(data as any[])
      }
    }catch(error){
      console.log({error})
    }
  }

  const invitationsList = useMemo(()=>{
    const invitationsList = apiInvitationsData?.map((item:IInvitedMerchant)=>{
      return {
        first_name: t("user_management.container.pending"),
        contact_email: item.merchant_email,
        last_name: "",
      }
    });
    if(!invitationsIsLoading){
      getMerchants();
    }
    return invitationsList;
  // eslint-disable-next-line  
  },[apiInvitationsData, invitationsIsLoading]);

  const usersList = useMemo(()=>{
    if(invitationsList){
      return (users.concat(invitationsList) ) as IMerchantAccount[];
    }else return []
  // eslint-disable-next-line  
  },[users,invitationsList]);

  return (
    <>
      <UserManagementView
        users={usersList}
        isLoading={isLoading || invitationsIsLoading}
      />
      <UserManagementDialogues
        users={users}
        callAPI={callAPI}
        invitationsListApi={invitationsListApi}
        getMerchants={getMerchants}
      />
    </>
  );
}

export default UserManagement;
